import { Combobox } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import {
  ADD_COMPANY_OPTION,
  ADD_COMPANY_SITE_OPTION,
  CompanySiteOptionType,
} from '../../../../common';
import { ActionOption, CompanySiteOption } from './components';

const TRANS_PATH = 'EDIT_COMPANY_LINK_FORM.BUSINESS_FIELDS';

type SiteSelectOptionsPropsType = {
  options: CompanySiteOptionType[];
  shouldShowAddCompany: boolean;
  shouldShowAddCompanySite: boolean;
};

export const SiteSelectOptions: React.FC<SiteSelectOptionsPropsType> = ({
  options,
  shouldShowAddCompany,
  shouldShowAddCompanySite,
}) => {
  const { t } = useTranslation();
  const addCompanyLabel = t(`${TRANS_PATH}.ADD_COMPANY_LABEL`);
  const addCompanySiteLabel = t(`${TRANS_PATH}.ADD_COMPANY_SITE_LABEL`);

  return (
    <Combobox.Options>
      {options.map((opt) => (
        <Combobox.Option key={opt.value} value={opt.value}>
          <CompanySiteOption label={opt.label} />
        </Combobox.Option>
      ))}
      {shouldShowAddCompany && (
        <Combobox.Option value={ADD_COMPANY_OPTION}>
          <ActionOption label={addCompanyLabel} />
        </Combobox.Option>
      )}
      {shouldShowAddCompanySite && (
        <Combobox.Option value={ADD_COMPANY_SITE_OPTION}>
          <ActionOption label={addCompanySiteLabel} />
        </Combobox.Option>
      )}
    </Combobox.Options>
  );
};
